import UIComponent from '../../common/UIComponent';
import { clearAllNode } from '../../common/Utils';
import log from 'loglevel';
import './index.css';

const TENCENT_DELAY = 90;

export default class H5TimeshiftProgress extends UIComponent {
  constructor(elementId, interfaces, videoId) {
    super();
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.videoNode = document.querySelector(`${videoId}`);
    this.init();

    this.interfaces.on(VhallPlayer.LOADED, e => {
      this.progressContainer.setAttribute('class', 'vhallPlayerh5-progress-container display');
    });

    this.interfaces.on(VhallPlayer.TIMEUPDATE, e => {
      // TODO: 解决IOS上 IndexSizeError: The index is not in the allowed range.  报错
      if (this.interfaces.getBuffered().length <= 0) {
        return;
      }
      // 当前进度条长度
      this.progressDuration = e.progressDuration;
      this.playedDuration = e.playedDuration;
      this.now = e.now;
      this.progressStartTime = e.progressStartTime;
      // 设置预加载条宽度
      const progressLoadValue =
        (this.interfaces.getBuffered().end(this.interfaces.getBuffered().length - 1) / this.progressDuration) * 100;
      this.progressLoad.style.width = progressLoadValue + '%';
      // seek状态时 不设置进度条的值
      if (this.isSeeking) {
        return;
      }
      // 设置播放进度条宽度
      const progressPlayValue = (this.playedDuration / this.progressDuration) * 100;
      if (progressPlayValue > 100) {
        return;
      }
      this.progressPlay.style.width = progressPlayValue + '%';
      this.scrubberBox.style.left = progressPlayValue + '%';
    });
  }

  init() {
    this.progressContainer = document.createElement('div');
    this.progressContainer.setAttribute('class', 'vhallPlayerh5-progress-container hide');
    this.progressContainer.ontouchstart = this.handleTouchDown.bind(this);

    this.progressLoad = document.createElement('div');
    this.progressLoad.setAttribute('class', 'vhallPlayerh5-progress-load');

    this.progressPlay = document.createElement('div');
    this.progressPlay.setAttribute('class', 'vhallPlayerh5-progress-play');
    this.progressPlay.style.width = '100%';

    this.scrubberBox = document.createElement('div');
    this.scrubberBox.setAttribute('class', 'vhallPlayerh5-progress-scrubberBox');
    this.scrubberBox.style.left = '100%';

    this.scrubber = document.createElement('div');
    this.scrubber.setAttribute('class', 'vhallPlayerh5-progress-scrubber');
    // this.scrubber.innerHTML = `<i></i>`;

    var bar = document.createElement('i');
    this.scrubber.appendChild(bar);

    this.progressContainer.appendChild(this.progressLoad);
    this.progressContainer.appendChild(this.progressPlay);
    this.scrubberBox.appendChild(this.scrubber);
    this.progressContainer.appendChild(this.scrubberBox);

    this.insertElement(this.elementId, this.progressContainer);
  }

  handleTouchDown(event) {
    // 按下鼠标时 则为正在seek
    this.isSeeking = true;
    const downClientX = event.targetTouches[0].clientX;
    const mouseX = downClientX - (this.progressContainer.offsetLeft + this.videoNode.offsetLeft);
    this.scrubberBox.style.left = (mouseX / this.progressContainer.offsetWidth) * 100 + '%';
    this.progressPlay.style.width = (mouseX / this.progressContainer.offsetWidth) * 100 + '%';
    this.progressLoad.style.width = 0 + '%';

    const progressPlayWidth = this.progressPlay.offsetWidth;
    // 播放条位置
    let newL = progressPlayWidth;

    document.ontouchmove = event => {
      // 移动的距离
      const moveL = event.targetTouches[0].clientX - downClientX;
      // 新的播放位置
      newL = progressPlayWidth + moveL;
      if (newL <= 0) {
        newL = 0;
      }
      if (newL >= this.progressContainer.offsetWidth) {
        newL = this.progressContainer.offsetWidth;
      }
      this.scrubberBox.style.left = (newL / this.progressContainer.offsetWidth) * 100 + '%';
      this.progressPlay.style.width = (newL / this.progressContainer.offsetWidth) * 100 + '%';

      // 显示时间
      this.handleTousemove(newL);
    };

    document.ontouchend = e => {
      const progressDuration = Date.now() / 1000 - this.progressStartTime;
      const delay =
        ((this.progressContainer.offsetWidth - newL) / this.progressContainer.offsetWidth) * progressDuration;
      const opts = {
        delay: delay
      };
      // 重置预加载条
      this.progressLoad.style.width = 0 + '%';
      // 关闭seek状态
      this.isSeeking = false;
      // 移除鼠标移动事件
      document.ontouchmove = null;
      // 移除鼠标抬起事件
      document.ontouchend = null;

      this.interfaces.handleTimeshiftPlay(opts, err => {
        log.error(`时移delay=${delay}`, err);
      });

      // 隐藏时间
      this.handleTouchend();
    };
  }

  handleTousemove(loc) {
    // 通过父子 选择器， 选中当前实例 UI下的 bubble Element -- Reason:  bubble Element 是另外一个类 - 创建的。
    const bubbleEl = this.videoNode.querySelector(`.vhallPlayer-h5progress-bubble`);
    bubbleEl.setAttribute('class', 'vhallPlayer-h5progress-bubble bubble-show');
    const locTime =
      this.now / 1000 -
      ((this.progressContainer.offsetWidth - loc) / this.progressContainer.offsetWidth) * this.progressDuration;
    const showTime = new Date(locTime * 1000).Format('yyyy-MM-dd hh:mm:ss').split(' ')[1];
    // bubbleEl.innerHTML = `<span style="color: white; font-size: 12px; margin-left: 16px">${showTime}</span>`;

    clearAllNode(bubbleEl);
    var bubspan = document.createElement('span');
    bubspan.setAttribute('style', 'color: white; font-size: 12px; margin-left: 16px');
    bubspan.textContent = showTime;
    bubbleEl.appendChild(bubspan);

    // 兼容手机华为浏览器不隐藏时间的问题
    clearTimeout(this._timeId);
    this._timeId = setTimeout(() => {
      const bubbleEl = this.videoNode.querySelector(`.vhallPlayer-h5progress-bubble`);
      bubbleEl.setAttribute('class', 'vhallPlayer-h5progress-bubble bubble-hide');
    }, 300);
  }

  handleTouchend() {
    const bubbleEl = this.videoNode.querySelector('.vhallPlayer-h5progress-bubble');
    bubbleEl.setAttribute('class', 'vhallPlayer-h5progress-bubble bubble-hide');
  }
}
